import type { SxProps } from "@mui/material"

import { AUTH_PAGE_BG, LIGHT_BLUE } from "../../constants/colors"

const container: SxProps = {
  position: "fixed",
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gridTemplateRows: "auto",
  justifyItems: "center",
  width: "100vw",
  height: "100vh",
  background: AUTH_PAGE_BG,
  overflow: "auto"
}

const contextContainer: SxProps = {
  width: { xs: "100vw", md: "48vw" },
  display: "flex",
  flexDirection: "column",
  paddingY: { xs: "3rem", xl: "5rem" },
  px: { xs: "20vw", sm: "20vw", md: "10vw", lg: "10vw" }
}

const headerContainer: SxProps = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between"
}

const outletContainer: SxProps = {
  pt: { xs: "2rem", sm: "3rem", md: "4rem" }
}

const carouselContainer: SxProps = {
  paddingTop: "10rem",
  px: "10vw",
  display: { xs: "none", md: "flex" },
  background: LIGHT_BLUE,
  justifyContent: "center",
  width: "50vw"
}

export default {
  container,
  contextContainer,
  headerContainer,
  carouselContainer,
  outletContainer
}
